module.exports = __webpack_public_path__ + "static/media/18ECA13.03d45237.jpg";